import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1264px;
  width: 100%;
`;

export const WrapperCards = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.v3.spacing.xxxs};
    margin-top: ${theme.v3.spacing.xxs};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;


export const CardItem = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    border-radius: ${theme.v3.border.radius.round};
    border: ${theme.v3.border.width.thin} solid ${theme.v3.colors.neutral[95]};
    display: flex;
    flex-direction: row;
    flex: auto;
    gap: ${theme.v3.spacing.nano};
    padding: ${theme.v3.spacing.xxs};
    width: 100%;
  `}
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardHeader = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: ${theme.v3.spacing.nano};
  `}
`;

export const CardTitle = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    line-height: ${theme.v3.font.lineHeight.relaxed};
  `}
`;

export const CardDescription = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes.small};
    height: 41px;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin-top: ${theme.v3.spacing.nano};
    font-weight: ${theme.v3.font.weights.regular};
    max-width: 393px;
  `}
`;

export const CardCtaWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.v3.spacing.xxxs};
  `}
`;

export const CardCtaColumn = styled.div`
  margin: auto;
  margin-right: 0;
`;
